export const getGameInfoPageViewedProps = () => ({
    openedFrom: 'opened_from'
});
